import { ListSortDirection, Sort } from "../../models/api/sort";
import { EmployeeDTO, EmployeeSTO } from "../../models/employees";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesApiService extends BaseApiService<EmployeeDTO, EmployeeSTO> {
  constructor() {
    super({
      servicePath: "/Employees",
      loadItemsPath: "/GetEmployees",
      saveItemsPath: "/SaveEmployees",
    });
    this.defaultSort = [
      {
        name: "firstName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "lastName",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
